<template>
  <button
      :class="[
      { small },
      { rounded },
      { medium },
      { outline },
      { fair },
      { transparent },
      { white },
      {
        'h-9': small
      },
      {
        'h-11': medium
      }
    ]"
      @click="$emit('click')"
      class="text-lg font-medium ui-button h-14"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    small: {
      type: Boolean,
      default: false
    },
    medium: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean,
      default: false
    },
    outline: {
      type: Boolean,
      default: false
    },
    fair: {
      type: Boolean,
      default: false
    },
    white: {
      type: Boolean,
      default: false
    },
    transparent: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-button {
  background: var(--color);
  color: #fff;
  display: inline-flex;
  align-items: center;
  font-family: inherit;
  border-radius: 6px;
  padding: 0 2em;
  justify-content: center;
  cursor: pointer;
  transition: 0.3s;
  & > * {
    margin-right: 0.8em;
  }
  &.small {
    padding: 0 1.2em;
    font-size: 16px;
  }
  &.medium {
    padding: 0 1.2em;
  }
  &.fair {
    background: var(--light);
    color: var(--color);
  }
  &.white {
    background: #fff;
    color: var(--color);
  }
  &.rounded {
    border-radius: 100px;
  }
  &.outline {
    background: transparent;
    border: solid 2px var(--color);
    color: var(--color);
    &:hover {
      background: var(--color);
      color: #fff;
    }
  }
  &.transparent {
    background: transparent;
    color: var(--color);
    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
